export function drawFlowingObservations(
  doc,
  {
    text = "",
    startY,
    x = 10,
    width,
    pageBottomMargin = 12,
    scheduleHeight = 9,
    scheduleGap = 3,
    drawPageFrame,
  }
) {
  const pageHeight = doc.internal.pageSize.getHeight();
  const boxWidth = width ?? doc.internal.pageSize.getWidth() - x * 2;
  const lineHeight = 4.2;
  const textFontSize = 8;
  const textTop = 4;
  const textBottom = 2.5;
  const minBoxHeight = 14;
  const normalizedText = String(text || "").trim();
  // Medir con exactamente la misma tipografía y tamaño usados al imprimir.
  // El contenido anterior del PDF (el link de Maps) deja la fuente en 6.5 pt.
  doc.setFont("helvetica", "normal");
  doc.setFontSize(textFontSize);
  let remainingLines = normalizedText
    ? doc.splitTextToSize(normalizedText, boxWidth - 4)
    : [];
  let sectionY = startY;
  let isFirstPage = true;

  const contentHeightFor = (lineCount) =>
    lineCount > 0
      ? textTop + (lineCount - 1) * lineHeight + textBottom
      : minBoxHeight;

  const lineCapacity = (boxY, bottomLimit) => {
    const available = bottomLimit - boxY;
    if (available < textTop + textBottom) return 0;
    return Math.max(
      1,
      Math.floor((available - textTop - textBottom) / lineHeight) + 1
    );
  };

  while (true) {
    const label = isFirstPage
      ? "Observaciones:"
      : "Observaciones (continuacion):";
    const boxY = sectionY + 6;
    const pageContentBottom = pageHeight - pageBottomMargin;
    const bottomWithSchedule =
      pageContentBottom - scheduleGap - scheduleHeight;
    const fullCapacity = lineCapacity(boxY, pageContentBottom);
    const capacityWithSchedule = lineCapacity(boxY, bottomWithSchedule);

    if (remainingLines.length > 0 && fullCapacity === 0) {
      doc.addPage();
      drawPageFrame?.(doc);
      sectionY = 10;
      isFirstPage = false;
      continue;
    }

    let pageLines;
    if (!remainingLines.length) {
      pageLines = [];
    } else if (remainingLines.length <= capacityWithSchedule) {
      pageLines = remainingLines;
    } else {
      pageLines = remainingLines.slice(0, fullCapacity);
    }

    const boxHeight = Math.max(minBoxHeight, contentHeightFor(pageLines.length));

    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.text(label, x, sectionY + 4);
    doc.setLineWidth(0.25);
    doc.rect(x, boxY, boxWidth, boxHeight);

    if (pageLines.length) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(textFontSize);
      pageLines.forEach((line, index) => {
        doc.text(line, x + 2, boxY + textTop + index * lineHeight);
      });
    }

    remainingLines = remainingLines.slice(pageLines.length);
    const boxBottom = boxY + boxHeight;

    if (!remainingLines.length) {
      const scheduleY = boxBottom + scheduleGap;
      if (scheduleY + scheduleHeight <= pageContentBottom) return scheduleY;

      doc.addPage();
      drawPageFrame?.(doc);
      return 12;
    }

    doc.addPage();
    drawPageFrame?.(doc);
    sectionY = 10;
    isFirstPage = false;
  }
}
